import { transformerCopyButton } from '@rehype-pretty/transformers';

/** @type {import('rehype-pretty-code').Options} */
export const rehypePrettyCodeOptions = {
  tokensMap: {
    fn: 'entity.name.function',
  },
  defaultLang: 'plaintext',
  onVisitLine(node: any) {
    if (node.children.length === 0) {
      node.children = [{ type: 'text', value: ' ' }];
    }
    node.properties.className = [''];
  },
  transformers: [
    transformerCopyButton({
      visibility: 'always',
      feedbackDuration: 3_000,
    }),
  ],
};
